import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { BackendService } from '../../core/backend.service';
import { SnackService } from '../../shared-services/snack.service';
import { CambioEmail } from '../../cliente/cambioEmail.model';
import { ApiService } from '../../core/api.service';
import { Cliente } from '../../cliente/cliente.model';
import { Email } from '../../security/user/email.model';
declare function escape(s: string): string;
@Component({
  selector: 'app-complete-cambio-email',
  templateUrl: './complete-cambio-email.component.html',
  styleUrls: ['./complete-cambio-email.component.scss']
})
export class CompleteCambioEmailComponent implements OnInit  {

  @Input() cliente: Cliente;
  @Input() cambioEmail: Email;
  @Output() onUpdateEmail = new EventEmitter<boolean>();
  private staticCambioEmail = { email: '' };
  operationalCambioEmail = { email: '' };
  private staticCliente = { username: '' };

  constructor(
    private backendService: BackendService,
    private apiService: ApiService,
    private snackService: SnackService
  ) { }

  hasCambioEmail() {
    if (this.staticCambioEmail.email !== '') {
      return true;
    }
    return false;
  }

  async save() {

    this.snackService.spinner(true);
    try {
      await this.backendService.changeEmail('/clientes/cambio_email?userId=' + this.cliente.id
                                    + '&email=' + encodeURIComponent(this.operationalCambioEmail.email));
      this.snackService.success('Email actualizado');
      this.updateView();
      this.snackService.spinner(false);
    } catch (error) {
      this.snackService.spinner(false);
      this.snackService.error(error.message);
    }
  }

  updateView() {
    this.staticCambioEmail.email = this.operationalCambioEmail.email;
 
  }

  ngOnInit() {
    if (this.cambioEmail) {
      this.staticCambioEmail.email = this.cambioEmail.direccion;
      this.operationalCambioEmail.email = this.cambioEmail.direccion;
      
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/complete-cambio-email/complete-cambio-email.component.ts